function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgBriefcase = function SvgBriefcase(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Briefcase' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M38,40 L46,40 L46,10 L38,10 L38,40 Z M2,40 L10,40 L10,10 L2,10 L2,40 Z M33.78,8 L48,8 L48,42 L0,42 L0,8 L14.22,8 L15.272,3.788 C15.83,1.558 17.824,0 20.123,0 L27.877,0 C30.176,0 32.17,1.558 32.728,3.788 L33.78,8 Z M17.212,4.272 L16.28,8 L31.72,8 L30.788,4.272 C30.453,2.935 29.256,2 27.877,2 L20.123,2 C18.744,2 17.547,2.935 17.212,4.272 Z M12,40 L36,40 L36,10 L12,10 L12,40 Z"
  }));
};

SvgBriefcase = pure(SvgBriefcase);
SvgBriefcase.displayName = 'SvgBriefcase';
export default SvgBriefcase;